import AuthService from '@/services/auth.service'

const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
if (user) { user.userData = JSON.parse(user.userData) }
const initialState = user
  ? { status: { loggedIn: true }, user: user }
  : { status: { loggedIn: false }, user: null }

export default {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(res => {
        res.userData = JSON.parse(res.userData)
        commit('loginSuccess', res)
        let to = '/'
        if (res.userData.userRoleNames.includes('SuperAdmin')) {
          to = '/superadmin/dashboard'
        } else if (res.userData.userRoleNames.includes('Admin')) {
          to = '/admin/dashboard'
        } else if (res.userData.userRoleNames.includes('Member')) {
          to = '/member/dashboard'
        } else if (res.userData.userRoleNames.includes('Agent')) {
          to = '/agent/dashboard'
        } else if (res.userData.userRoleNames.includes('Sponsor')) {
          to = '/sponsor/dashboard'
        } else if (res.userData.userRoleNames.includes('CustomerMarketer')) {
          to = '/customermarketer/dashboard'
        }
        return Promise.resolve(to)
      }).catch(error => {
        commit('loginFailure')
        return Promise.reject(error)
      })
    },
    otpLogin({ commit }, data) {
      return AuthService.otpLogin(data).then(res => {
        if (res.roles) {
          return Promise.resolve({ roles: res.roles, to: '' })
        }
        else if (res.jwtToken) {
          res.jwtToken.userData = JSON.parse(res.jwtToken.userData)
          commit('loginSuccess', res.jwtToken)
          let to = '/'
          let roleNames = res.jwtToken.userData.userRoleNames
          if (roleNames.includes('SuperAdmin')) {
            to = '/superadmin/dashboard'
          } else if (roleNames.includes('Admin')) {
            to = '/admin/dashboard'
          } else if (roleNames.includes('Member')) {
            to = '/member/dashboard'
          } else if (roleNames.includes('Agent')) {
            to = '/agent/dashboard'
          } else if (roleNames.includes('CustomerMarketer')) {
            to = '/customermarketer/dashboard'
          }
          return Promise.resolve({ roles: null, to: to })
        }
        throw 'Token not found'
      }).catch(error => {
        commit('loginFailure')
        return Promise.reject(error)
      })
    },
    logout({ commit }) {
      AuthService.logout()
      commit('logout')
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess')
          return Promise.resolve(response.data)
        },
        error => {
          commit('registerFailure')
          return Promise.reject(error)
        },
      )
    },
    refreshUserClaims({ commit, state }) {
      if (!state.user?.userData)
        return
      AuthService.getUserClaim(state.user?.userData).then(response => {
        commit('SET_USER_CLAIMS', response)
      })
    },
  },
  mutations: {
    SET_USER_CLAIMS(state, claims) {
      if (state.user) {
        state.user.userData.claims = claims
      }
    },
    loginSuccess(state, user) {
      state.status.loggedIn = true
      state.user = user
    },
    loginFailure(state) {
      state.status.loggedIn = false
      state.user = null
    },
    logout(state) {
      state.status.loggedIn = false
      state.user = null
    },
    registerSuccess(state) {
      state.status.loggedIn = false
    },
    registerFailure(state) {
      state.status.loggedIn = false
    },
  },
  getters: {
    isAdmin: (state) => {
      return state.user?.userData?.userRoleNames?.includes('Admin')
    },
    isMember: (state) => {
      return state.user?.userData?.userRoleNames?.includes('Member')
    },
    getCurrentUser: (state) => {
      return state.user
    },
    getCurrentUserClaims: (state) => {
      return state.user?.userData?.claims
    },
    isSuperAdmin: (state) => {
      return state.user?.userData?.isSuperAdmin
    }
  },
}
